export default "https://cdn-static-staging.gokick.com/assets/8a9bc5ae92c259feb7c9591453bfa6ace937db28/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";